import React from 'react'

//
import Loader from '../../storybook/Loader'

const LoadingMessage = ({ title, text }) => (
  <div className="c-hubspot-form c-hubspot-form-thank-you">
    <Loader />
    <h4>{title}</h4>
    <p>{text}</p>
  </div>
)

export default LoadingMessage
